var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23Z",
    fill: "#FEF0C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27.5C32 27.88 31.79 28.21 31.47 28.38L23.57 32.82C23.41 32.94 23.21 33 23 33C22.79 33 22.59 32.94 22.43 32.82L14.53 28.38C14.3696 28.2958 14.2354 28.1693 14.1419 28.0141C14.0485 27.859 13.9994 27.6811 14 27.5V18.5C14 18.12 14.21 17.79 14.53 17.62L22.43 13.18C22.59 13.06 22.79 13 23 13C23.21 13 23.41 13.06 23.57 13.18L31.47 17.62C31.79 17.79 32 18.12 32 18.5V27.5ZM23 15.15L21.11 16.22L27 19.61L28.96 18.5L23 15.15ZM17.04 18.5L23 21.85L24.96 20.75L19.08 17.35L17.04 18.5ZM16 26.91L22 30.29V23.58L16 20.21V26.91ZM30 26.91V20.21L24 23.58V30.29L30 26.91Z",
    fill: "#DC6803"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 43.4856L23.6274 51.4616C23.2607 51.7579 22.737 51.7578 22.3704 51.4616L12.5 43.4854L33.5 43.4856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMarker);
export default __webpack_public_path__ + "static/media/load-marker.35d12e48c1e76ec7ebaca2f4e7b629b0.svg";
export { ForwardRef as ReactComponent };